var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"p-connected-overlay"},on:{"enter":_vm.onEnter,"leave":_vm.onLeave}},[(_vm.popup ? _vm.visible : true)?_c('div',{ref:"container",class:_vm.containerClass},[_c('TieredMenuSub',{attrs:{"model":_vm.model,"root":true,"popup":_vm.popup,"exact":_vm.exact},on:{"leaf-click":_vm.onLeafClick}})],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2406dae7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/primevue/tieredmenu/TieredMenu.vue
// module id = X6cE
// module chunks = 38